import { PageWithDescriptionsProps } from 'strapi/page/types';

import { collectImageComponentParams } from '../../shared/collector';
import { KeyPointsProps } from '../../shared/KeyPointsColumn/types';

export const createKeyPoint = (
  page: PageWithDescriptionsProps
): KeyPointsProps => ({
  title: page.descriptiveName,
  description: [
    {
      type: 'paragraph',
      children: [{ type: 'text', text: page.pageDescription }],
    },
  ],
  url: page.path,
  image: collectImageComponentParams(page.cover)!,
});
